module.exports = __webpack_public_path__ + "static/media/anularXazul.8c1c3b1a.svg";